export const TECHNICAL_SHEET = 'TechnicalSheet';
export const TechnicalSheetKindValues = [
    'guided',
    'template',
];
//# sourceMappingURL=technical-sheet.js.map